import styled from 'styled-components';

export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 200;
  background: ${({ theme }) => theme.background + theme.transparency.t50};
`;

/** Moved along the overlay by ListFetchingOverlay; 100px, the spinner's box. */
export const SpinnerSpot = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
`;
